import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AutocompleteDataLoader } from 'src/app/components/autocomplete/autocomplete-data-loader';
import { AutocompleteOption } from 'src/app/components/autocomplete/autocomplete-option';
import { ReturnMessage } from 'src/app/models/return-message';
import { ContactService } from '../contact/contact.service';
import { ResponseContacts } from 'src/app/models/response-contacts';

@Injectable() // Not a singleton
export class ContactAutocompleteDataLoaderService implements AutocompleteDataLoader {

  configuration: {
    customerNumber: string;
    addressCode: string;
    searchField: string;
  }

  set configurationSetter(configuration: { customerNumber: string; addressCode: string; searchField: string; }) 
  { 
    this.configuration = configuration; 
  }
  get configurationGetter() { return this.configuration; }

  constructor(private contactService: ContactService) { }

  load(searchTerm: string): Observable<ReturnMessage<AutocompleteOption[]>> {
    if (!this.configuration)
      throw Error("Configuration not set.");

    let params = { 
      searchAll: false,
      searchTerm: searchTerm, 
      customerNumber: this.configuration.customerNumber, 
      addressCode: this.configuration.addressCode, 
      searchField: this.configuration.searchField
    };
    return this.contactService.getCustomerAddressContact(params)
      .pipe(
        map(response => {
          return this.transformResponse(response);
        })
      );
  }

  loadAll(): Observable<ReturnMessage<AutocompleteOption[]>> {
    if (!this.configuration)
      throw Error("Configuration not set.");

      let params = { 
        searchAll: true,
        searchTerm: null, 
        customerNumber: this.configuration.customerNumber, 
        addressCode: this.configuration.addressCode, 
        searchField: this.configuration.searchField
      };
      return this.contactService.getCustomerAddressContact(params)
        .pipe(
          map(response => {
            return this.transformResponse(response);
          })
        );
  }

  transformResponse(response: ReturnMessage<ResponseContacts[]>) {

    let newReturnMessage = <ReturnMessage<AutocompleteOption[]>>{
      success: response.success,
      message: response.message,
      title: response.title,
      options: response.options,
      returncode: response.returncode
    };

    if (response.success) {
      newReturnMessage.payload = <AutocompleteOption[]>[];
      for (const contact of response.payload) {
        newReturnMessage.payload.push({ 
          id: contact.contactId, 
          description: contact.name, 
          sourceObject: contact 
        });
      }
    }

    return newReturnMessage;
  }
}